import {$dom} from '../helpers/dom';
import is from 'is_js';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';

class Form {
  constructor() {
    this.form = null;
  }

  initInputs() {
    if (this.form) {
      this.maskPhone('input[type="tel"]');
      this.form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        const $inputs = this.form.querySelectorAll('.form-control');
        $inputs.forEach((input) => {
          const $errorElement = input.parentElement.querySelector('.error-text');
          if (input.required && !input.value) {
            this.setError(input, 'Обязательное поле');
          } else {
            this.removeError(input, $errorElement);
          }
          this.validateFields(input);
        })
        const errors = this.form.querySelectorAll('.error')
        if (!errors.length) {
          this.submit()
        }
      });
    }
  };

  initCheckbox() {
    const $checkbox = this.form.querySelector('#consent');
    const $button = this.form.querySelector('button[type="submit"]');
    $checkbox.addEventListener('change', () => {
      if ($checkbox.checked) {
        $button.classList.remove('disabled')
      } else {
        $button.classList.add('disabled')
      }
    })
  }

  checkInputs() {
    this.form.querySelectorAll('.form-control').forEach((input) => {
      input.addEventListener('input', (evt) => {
        const $input = evt.target;
        this.validateFields($input)
      })
    })
  }

  validateFields(input) {
    const errorElement = input.parentElement.querySelector('.error-text');
    if (input.name === 'phone') {
      if (input.value && !this.isPhone(input.value)) {
        if (!errorElement) {
          this.setError(input, 'Введите правильный телефон');
        }
      } else {
        this.removeError(input, errorElement)
      }
    }
    if (input.name === 'email') {
      if (input.value && !is.email(input.value)) {
        if (!errorElement) {
          this.setError(input, 'Введите правильный email');
        }
      } else {
        this.removeError(input, errorElement)
      }
    }
  }

  removeError(input, errorElement) {
    input.classList.remove('error');
    if (errorElement) {
      errorElement.remove();
    }
  }

  isPhone(value) {
    const phone = value.replace(/[\s-_+()]/g, '')
    const re = /^\d{6,11}$/;
    return re.test(phone);
  }

  setError(input, text) {
    const error = document.createElement('span');
    error.classList.add('error-text')
    error.textContent = text;
    input.classList.add('error');
    input.parentElement.insertAdjacentElement('beforeend', error);
  }

  maskPhone(selector, masked = '+7 (___) ___-__-__') {
    const elems = document.querySelectorAll(selector);

    function mask(event) {
      const keyCode = event.keyCode;
      const template = masked,
        def = template.replace(/\D/g, ""),
        val = this.value.replace(/\D/g, "");

      let i = 0,
        newValue = template.replace(/[_\d]/g, function (a) {
          return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
        });
      i = newValue.indexOf("_");
      if (i !== -1) {
        newValue = newValue.slice(0, i);
      }
      let reg = template.substr(0, this.value.length).replace(/_+/g,
        function (a) {
          return "\\d{1," + a.length + "}";
        }).replace(/[+()]/g, "\\$&");
      reg = new RegExp("^" + reg + "$");
      if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) {
        this.value = newValue;
      }
      if (event.type === "blur" && this.value.length < 5) {
        this.value = "";
      }

    }

    for (const elem of elems) {
      elem.addEventListener("input", mask);
      elem.addEventListener("focus", mask);
      elem.addEventListener("blur", mask);
    }

  }

  async submit() {
    const formData = new FormData(this.form);
    const response = await axios.post('/_ajax/', formData);
    if (response.status === 200) {

      Swal.fire({
        title: 'Заявка успешно отправлена!',
        text: "Менеджер свяжется с Вами в ближайшее время.",
        icon: 'success',
        showConfirmButton:false,
        showCloseButton:true,
        timer: 4000
      })

    }
    this.form.querySelectorAll('.form-control').forEach(input => input.value = '');
  }

  init() {
    const {get} = $dom;
    this.form = get('.feedback-form');
    this.initInputs();
    this.initCheckbox();
    this.checkInputs();
  }
}


const initForm = () => {
  const form = new Form();
  form.init();
}
export default initForm;
